// import { BaseScript } from "../../BaseScript";
// import Index from "../../Index";

import { RichHelper } from "./RichHelper";
import Sprite = Laya.Sprite;
import SpriteUtils = Laya.SpriteUtils;
import Render = Laya.Render;
import Browser = Laya.Browser;
const { regClass, property } = Laya;

@regClass('lrXfxJhSRhWp8OF2XbiP2Q')
export class pvp extends Laya.Script {
    //declare owner : Laya.Sprite3D;
    //declare owner : Laya.Sprite;
    private video: any;
    private div: any;
    @property(String)
    public text: string = "";
    private myChart: { setOption: any };
    private data: any;
    private option: any;
    private sprDiv: Sprite;
    // public pageWidth: number;
    // public pageHeight: number;
    //组件被激活后执行，此时所有节点和组件均已创建完毕，此方法只执行一次
    onAwake(): void {

        // 设置画布上的对齐参照物
        this.sprDiv = new Sprite();
        var reference: Sprite = this.sprDiv;
        this.owner.addChild(reference);
        //reference.pos((this.pageWidth - 600) / 2, (this.pageHeight - 400) / 2);
        reference.pos(0, 0);
        reference.size(1024, 1824);
        reference.graphics.drawRect(0, 0, reference.width, reference.height, "#000000");

        // 每次尺寸变更时，都会调用Utils.fitDOMElementInArea设置Video的位置，对齐的位置和refence重合
        // if (Index.curPage)
        //     SpriteUtils.fitDOMElementInArea(videoElement, reference, Index.pagePos.x, Index.pagePos.y, reference.width, reference.height);
        // else
        //     SpriteUtils.fitDOMElementInArea(videoElement, reference, 0, 0, reference.width, reference.height);
        this.initEChart();
        this.initOption3();
        SpriteUtils.fitDOMElementInArea(this.div, reference, 0, 0, reference.width, reference.height);
    }
    // public initOption1(): void {
    //     this.option = {
    //         title: {
    //             text: '左上角标题'
    //         },
    //         tooltip: {},
    //         legend: {
    //             data: ['居中标题']
    //         },
    //         xAxis: {
    //             data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
    //         },
    //         yAxis: {},
    //         series: [{
    //             name: '居中标题',
    //             type: 'bar',
    //             data: [5, 20, 36, 10, 10, 20]
    //         }]
    //     };
    //     // 使用刚指定的配置项和数据显示图表。
    //     this.myChart.setOption(this.option);
    // }
    // public async initOption2(): Promise<void> {
    //     const updateFrequency = 2000;
    //     const dimension = 0;
    //     const countryColors: Record<string, string> = {
    //         Australia: '#00008b',
    //         Canada: '#f00',
    //         China: '#ffde00',
    //         Cuba: '#002a8f',
    //         Finland: '#003580',
    //         France: '#ed2939',
    //         Germany: '#000',
    //         Iceland: '#003897',
    //         India: '#f93',
    //         Japan: '#bc002d',
    //         'North Korea': '#024fa2',
    //         'South Korea': '#000',
    //         'New Zealand': '#00247d',
    //         Norway: '#ef2b2d',
    //         Poland: '#dc143c',
    //         Russia: '#d52b1e',
    //         Turkey: '#e30a17',
    //         'United Kingdom': '#00247d',
    //         'United States': '#b22234'
    //     };
    //     let startIndex = 10;
    //     const years: string[] = [];
    //     let startYear = years[startIndex];
    //     var str = await Laya.loader.load('life.json', Laya.Loader.JSON);


    //     this.data = str.data;
    //     var data = this.data;
    //     for (let i = 0; i < data.length; ++i) {
    //         if (years.length === 0 || years[years.length - 1] !== data[i][4]) {
    //             years.push(data[i][4]);
    //         }
    //     }
    //     console.log("loaded");
    //     this.option = {
    //         grid: {
    //             top: 10,
    //             bottom: 30,
    //             left: 150,
    //             right: 80
    //         },
    //         xAxis: {
    //             max: 'dataMax',
    //             axisLabel: {
    //                 formatter: function (n: number) {
    //                     return Math.round(n) + '';
    //                 }
    //             }
    //         },
    //         dataset: {
    //             source: data.slice(1).filter(function (d: string[]) {
    //                 return d[4] === startYear;
    //             })
    //         },
    //         yAxis: {
    //             type: 'category',
    //             inverse: true,
    //             max: 10,
    //             axisLabel: {
    //                 show: true,
    //                 fontSize: 14,
    //                 formatter: function (value: any) {
    //                     return value + '{flag|}';
    //                 },
    //                 rich: {
    //                     flag: {
    //                         fontSize: 25,
    //                         padding: 5
    //                     }
    //                 }
    //             },
    //             animationDuration: 300,
    //             animationDurationUpdate: 300
    //         },
    //         series: [
    //             {
    //                 realtimeSort: true,
    //                 seriesLayoutBy: 'column',
    //                 type: 'bar',
    //                 itemStyle: {
    //                     color: function (param: any) {
    //                         return countryColors[(param.value as number[])[3]] || '#5470c6';
    //                     }
    //                 },
    //                 encode: {
    //                     x: dimension,
    //                     y: 3
    //                 },
    //                 label: {
    //                     show: true,
    //                     precision: 1,
    //                     position: 'right',
    //                     valueAnimation: true,
    //                     fontFamily: 'monospace'
    //                 }
    //             }
    //         ],
    //         // Disable init animation.
    //         animationDuration: 0,
    //         animationDurationUpdate: updateFrequency,
    //         animationEasing: 'linear',
    //         animationEasingUpdate: 'linear',
    //         graphic: {
    //             elements: [
    //                 {
    //                     type: 'text',
    //                     right: 160,
    //                     bottom: 60,
    //                     style: {
    //                         text: startYear,
    //                         font: 'bolder 80px monospace',
    //                         fill: 'rgba(100, 100, 100, 0.25)'
    //                     },
    //                     z: 100
    //                 }
    //             ]
    //         }
    //     };

    //     // console.log(option);
    //     this.myChart.setOption(this.option);
    //     var that = this;
    //     for (let i = startIndex; i < years.length - 1; ++i) {
    //         // (function (i) {
    //         //     setTimeout(function () {
    //         //         that.updateYear(years[i + 1]);
    //         //     }, (i - startIndex) * updateFrequency);
    //         // })(i);
    //         Laya.stage.timerOnce((i - startIndex) * updateFrequency, that, () => { that.updateYear(years[i + 1]); });
    //     }

    // }
    public updateYear(year: string): void {
        console.log(year);
        let source = this.data.slice(1).filter(function (d: string[]) {
            return d[4] === year;
        });
        (this.option as any).series[0].data = source;
        (this.option as any).graphic.elements[0].style.text = "第" + year + "期";
        this.myChart.setOption(this.option);
    }

    public IdNames: Map<string, string> = new Map<string, string>();

    public async initOption3(): Promise<void> {
        const updateFrequency = 2000 * 2;
        const dimension = 0;
        const countryColors: Record<string, string> = {
            Wind: '#228B22',
            Water: '#1E90FF',
            Fire: '#DC143C',
            Earth: '#D2691E',
            Light: '#FFF8DC',
            Dark: '#4B0082',
            Default: '#A9A9A9'

        };
        let startIndex = 0;
        const years: string[] = [];
        let startYear = years[startIndex];
        //var str = await Laya.loader.load('life.json', Laya.Loader.JSON);
        var str = await Laya.loader.load('resources/pvp_heroall.json', Laya.Loader.JSON);


        this.data = str.data;
        var data = this.data;
        for (let index = 0; index < data.length; index++) {
            const element: Array<string> = data[index];
            this.IdNames.set(element[2], element[0]);
        }
        for (let i = 0; i < data.length; ++i) {
            if (years.length === 0 || years[years.length - 1] !== data[i][4]) {
                years.push(data[i][4]);
            }
        }
        var ids = this.IdNames;
        console.log("loaded");
        var allrichicon = RichHelper.getAllRichIcon();
        this.option = {
            tooltip: {
                show: true,
                formatter: function (v: any) {
                    return '<img src="' + RichHelper.getIconUrl(v.value[2]) + '"/> id:' + v.value[2] + " " + v.value[0] + ' 出场次数' + v.value[1];
                },
            },
            title: {
                text: '樱境物语天命排行榜出场出场次数前30',
                left: 'center',
                top: 20,
                textStyle: {
                    fontSize: 24,
                    color: '#FFF'
                }

            },
            grid: {
                top: 100,
                bottom: 30,
                left: 200,
                right: 80
            },
            xAxis: {
                max: 'dataMax',
                axisLabel: {
                    formatter: function (n: number) {
                        return Math.round(n) + '';
                    },
                    // padding:[0,0,0,-120]
                }
            },
            dataset: {
                source: data.slice(1).filter(function (d: string[]) {
                    return d[4] === startYear;
                })
            },
            yAxis: {
                type: 'category',
                inverse: true,
                max: 30,
                axisLabel: {
                    show: true,
                    fontSize: 24,
                    formatter: function (value: any) {
                        return ids.get(value) + '{' + value + '|}';
                    },
                    // padding:[0,0,0,-120],
                    rich: allrichicon
                },
                animationDuration: 2000,
                animationDurationUpdate: updateFrequency/2,

            },
            series: [
                {
                    realtimeSort: true,
                    seriesLayoutBy: 'column',
                    type: 'bar',
                    itemStyle: {
                        color: function (param: any) {
                            return countryColors[(param.value as number[])[3]] || '#5470c6';
                        }
                    },
                    encode: {
                        tooltip: [1, 2],
                        x: 1,
                        y: 2
                    },
                    label: {
                        show: true,
                        precision: 1,
                        position: 'right',
                        valueAnimation: true,
                        fontFamily: 'monospace'
                    }
                }
            ],
            // Disable init animation.
            animationDuration: 0,
            animationDurationUpdate: updateFrequency,
            animationEasing: 'linear',
            animationEasingUpdate: 'linear',
            graphic: {
                elements: [
                    {
                        type: 'text',
                        right: 160,
                        bottom: 60,
                        style: {
                            text: "第" + startYear + "期",
                            font: 'bolder 80px monospace',
                            fill: 'rgba(100, 100, 100, 0.25)'
                        },
                        z: 100
                    }, {
                        type: 'text',
                        right: 160,
                        bottom: 260,
                        style: {
                            text: "整理于2023/12/04\n\nS2 魔法数字",
                            font: 'bolder 18px monospace',
                            fill: 'rgba(255, 255, 255, 1)'
                        },
                        z: 100
                    }
                ]
            }
        };

        // console.log(option);
        this.myChart.setOption(this.option);
        var that = this;
        for (let i = startIndex; i < years.length - 1; ++i) {
            Laya.stage.timerOnce((i - startIndex) * updateFrequency, that, () => { that.updateYear(years[i + 1]); });
        }

    }
    public initEChart(): void {
        const div = Laya.Browser.document.createElement("div");
        div.style.width = "1000";
        div.style.height = "1800";
        div.style.position = "absolute";
        div.style.top = "0";
        div.style.right = "0";
        this.div = div;
        Laya.Browser.document.body.appendChild(this.div);
        this.myChart = new Laya.Browser.window.echarts.init(this.div);
        Laya.Browser.window.addEventListener("resize", () => { console.log("resize"); });
    };

    // public initEChart(): void {
    //     //laya相关代码

    //     this.div = Laya.Browser.document.createElement("div");
    //     this.div.style.width = this.sprDiv.width + "px";// "600px";
    //     this.div.style.height = this.sprDiv.height + "px"; //"600px";
    //     Laya.Browser.document.body.appendChild(this.div);
    //     this.myChart = new Laya.Browser.window.echarts.init(this.div);       
    //     // if( Index.curPage )
    //     // SpriteUtils.fitDOMElementInArea(this.div, this.box2D, Index.pagePos.x, Index.pagePos.y, this.pageWidth, this.pageHeight);

    //     // SpriteUtils.fitDOMElementInArea(videoElement, reference, 0, 0, reference.width, reference.height);       
    // }

    //组件被启用后执行，例如节点被添加到舞台后
    //onEnable(): void {}

    //组件被禁用时执行，例如从节点从舞台移除后
    //onDisable(): void {}

    //第一次执行update之前执行，只会执行一次
    //onStart(): void {}

    //手动调用节点销毁时执行
    //onDestroy(): void {}

    //每帧更新时执行，尽量不要在这里写大循环逻辑或者使用getComponent方法
    //onUpdate(): void {}

    //每帧更新时执行，在update之后执行，尽量不要在这里写大循环逻辑或者使用getComponent方法
    //onLateUpdate(): void {}

    //鼠标点击后执行。与交互相关的还有onMouseDown等十多个函数，具体请参阅文档。
    //onMouseClick(): void {}
}